import {PlayerReduxState} from "../types";

export default function isAdaptiveResponsePlaybackActive(state: PlayerReduxState): boolean {
  const adaptiveInput = state.adaptiveInput;

  if (!adaptiveInput?.startedPlaying) {
    return false;
  }

  return adaptiveInput.responses.some((response) => !response.played);
}
